
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zhanr/[alias]",
      function () {
        return require("private-next-pages/zhanr/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zhanr/[alias]"])
      });
    }
  